import { useTranslation } from "react-i18next";
import styles from "../../PPTPlugin/PPTInstallGuidePage.module.css";
import CHROME_URL from "./images/browser_icon_chrome.png";
import FIREFOX_URL from "./images/browser_icon_firefox.png";
import SAFARI_URL from "./images/browser_icon_safari.png";
import OPERA_URL from "./images/browser_icon_opera.png";
import BRAVE_URL from "./images/browser_icon_brave.png";
import EDGE_URL from "./images/browser_icon_edge.png";


export default function SupportedBrowserList() {
    const { t } = useTranslation();
    return (
        <div
            className={styles.row}
            style={{
                gap: 12, flexWrap: "wrap", flex: 1,
                minWidth: 260, height: "min-content",
                alignSelf: "center", marginLeft: "auto", justifyContent: "end"
            }}
        >
            <div className={styles.row} style={{gap: 12}}>
                <div className={styles.browserIcon}>
                    <img
                        src={CHROME_URL}
                        alt={t("integration.chromeIconAlt")}
                    />
                </div>

                <div className={styles.browserIcon}>
                    <img
                        src={FIREFOX_URL}
                        alt={t("integration.firefoxIconAlt")}
                    />
                </div>

                <div className={styles.browserIcon}>
                    <img
                        src={SAFARI_URL}
                        alt={t("integration.safariIconAlt")}
                    />
                </div>

            </div>
            <div className={styles.row} style={{gap: 12, flexWrap: "wrap"}}>
                <div className={styles.browserIcon}>
                    <img
                        src={OPERA_URL}
                        alt={t("integration.operaIconAlt")}
                    />
                </div>

                <div className={styles.browserIcon}>
                    <img
                        src={BRAVE_URL}
                        alt={t("integration.braveIconAlt")}
                    />
                </div>

                <div className={styles.browserIcon}>
                    <img
                        src={EDGE_URL}
                        alt={t("integration.edgeIconAlt")}
                    />
                </div>
            </div>
        </div>
    );
}